import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import Logo from './Logo';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isMenuOpen && !e.target.closest('.nav') && !e.target.closest('.mobile-toggle')) {
        setIsMenuOpen(false);
      }
    };

    // Close menu when resizing above mobile breakpoint
    const handleResize = () => {
      if (window.innerWidth > 768 && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('resize', handleResize);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('resize', handleResize);
    };
  }, [isMenuOpen]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Custom scroll handler
  const handleNavClick = (e, targetId) => {
    e.preventDefault(); // Prevent default anchor behavior
    setIsMenuOpen(false); // Close mobile menu if open

    // Check if we're on a policy page (not the main page)
    const currentPath = window.location.pathname;
    const isOnMainPage = currentPath === '/';
    
    if (!isOnMainPage) {
      // If on a policy page, navigate to main page with hash
      window.location.href = `/#${targetId}`;
      return;
    }

    // Use 'home' for the root path or if targetId is missing/invalid
    const idToScroll = targetId && document.getElementById(targetId) ? targetId : 'home';
    
    if (idToScroll === 'home') {
        // Scroll to top for 'home'
        window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
        const targetElement = document.getElementById(idToScroll);
        if (targetElement) {
          const headerOffset = 80; // Adjust based on your actual header height
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container header-container">
        <Logo />

        <div className="mobile-toggle" onClick={toggleMenu} aria-label="Toggle navigation">
          <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
        </div>

        <nav className={`nav ${isMenuOpen ? 'active' : ''}`}>
          <ul className="nav-list">
            <li><a href="#home" onClick={(e) => handleNavClick(e, 'home')}>Home</a></li>
            <li><a href="#about" onClick={(e) => handleNavClick(e, 'about')}>About Us</a></li>
            <li><a href="#projects" onClick={(e) => handleNavClick(e, 'projects')}>Case Studies</a></li>
            <li><a href="#skills" onClick={(e) => handleNavClick(e, 'skills')}>Services</a></li>
            <li><a href="#pricing" onClick={(e) => handleNavClick(e, 'pricing')}>Pricing</a></li>
            <li><a href="#faq" onClick={(e) => handleNavClick(e, 'faq')}>FAQ</a></li>
            <li><a href="#contact" onClick={(e) => handleNavClick(e, 'contact')}>Contact Us</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;